var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    padding: '50px'
  })},[_c('p',{style:({
      textAlign: 'center',
      fontSize: '1.2rem'
    })},[_vm._v(" "+_vm._s(_vm.note)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }